import React from 'react';

import { scenarios } from './scenarios';

export const pages = [
  {
    index: 0,
    en: { title: undefined },
    es: { title: undefined },
    qu: { title: undefined },
  },
  {
    index: 1,
    en: {
      title: '',
      fields: [
        'Welcome to the Agricultural Optimizer',
        'This tool can help farmers in the Colca Valley, Peru, make decisions about planting mix of crops based on an allocated water supply, crop water needs, and/or profits.',
        'Continue',
        'In no event shall the creators, custodians, or distributors of this information be liable for any damages arising out of its use (or the inability to use it).',
      ],
    },
    es: {
      title: '',
      fields: [
        'Bienvenido a la herramienta de Optimizador agrícola',
        'Esta herramienta puede ayudar a los agricultores en el Valle de Colca, Perú, a tomar decisiones sobre sembrar una mezcla de cultivos basado en el suministro de agua asignado, el uso de agua de cultivos, y/o ganancias.',
        'Continuar',
        'En ningún caso los creadores, custodios o distribuidores de esta información serán responsables de los daños que surjan de su uso (o la imposibilidad de usarla).',
      ],
    },
    qu: {
      title: '',
      fields: ['TRANSLATE', 'TRANSLATE', 'TRANSLATE', 'TRANSLATE'],
    },
  },
  {
    index: 2,
    en: {
      title: 'Select nearest weather station',
      fields: [
        'Selected station',
        'How much land area would you like to plant?',
        'Which units?',
      ],
    },
    es: {
      title: 'Seleccione la estación mas cercana',
      fields: [
        'Seleccione la estación',
        '¿Cuánto área de terreno quiere sembrar?',
        '¿Qué unidades?',
      ],
    },
    qu: {
      title: 'Qaylla estacionta akllay',
      fields: ['Estacionta akllay', 'Ch’usaq chaqra tarpunapaq', 'Akllay'],
    },
  },
  {
    index: 3,
    en: {
      title: 'Water access',
      fields: [
        'Water access frequency',
        'Number of times per month you have access to water.',
        'Water access duration',
        'Duration of water access in hours.',
        'Water flow rate (L/s)',
        'Estimated flow rate of water (L/s).',
      ],
    },
    es: {
      title: 'Aceso al agua',
      fields: [
        'Frecuencia de aceso al agua (veces por mes)',
        'Número de veces al mes que tiene acceso al agua.',
        '¿Por cuantas horas tienes aceso al agua?',
        'Duración del acceso al agua en horas.',
        'Flujo de agua estimado (Litro/Segundo)',
        'Caudal estimado de agua (L/s).',
      ],
    },
    qu: {
      title: 'Unu qarpa punku',
      fields: [
        'Juk killapi, Jayk’a kuti unuta chaskinki?',
        'TRANSLATE',
        'Sapa kuti, Jayk’a horas unuta chaskinki?',
        'TRANSLATE',
        'Jayk’a unu jaykun (jayk’a litro juk segundopi)',
        'TRANSLATE',
      ],
    },
  },
  {
    index: 4,
    en: {
      title: 'Select crops to plant (up to 4):',
      fields: [
        'alfalfa',
        'barley',
        'broad beans',
        'corn',
        'peas',
        'potato',
        'quinoa',
      ],
    },
    es: {
      title: 'Elige cultivos para sembrar (hasta 4):',
      fields: [
        'alfalfa',
        'cebada',
        'habas',
        'maiz',
        'arveja',
        'papa',
        'quinua',
      ],
    },
    qu: {
      title: 'Tarpunapaq mujuta akllay (tawata akllay)',
      fields: [
        'alfalfa',
        'cebada',
        'habas',
        'sara',
        'alverjas',
        'papa',
        'kinuwa',
      ],
    },
  },
  {
    index: 5,
    en: {
      title: 'Market price (S/. Per kg)',
      fields: [
        'Please review and modify the default numbers based on the best of your knowledge.',
      ],
      unit: 'S/. Per kg',
    },
    es: {
      title: 'Precio del mercado (S/. al kg)',
      fields: [
        'Por favor revise y modifique los números predeterminados en función de lo mejor de su conocimiento.',
      ],
      unit: 'S/. al kg',
    },
    qu: {
      title: 'Qatupi jayk’a soles juk kilogramo kan?',
      fields: ['TRANSLATE'],
      unit: 'Jayk’a soles juk kilogramo',
    },
  },
  {
    index: 6,
    en: {
      title: {
        ha: 'Cost to plant (S/. Per ha)',
        topos: 'Cost to plant (S/. Per topos)',
      },
      fields: [
        'Please review and modify the default numbers based on the best of your knowledge.',
      ],
      unit: { ha: 'S/. Per ha', topos: 'S/. Per topos' },
    },
    es: {
      title: {
        ha: 'Costo para sembrar (S/. al ha)',
        topos: 'Costo para sembrar (S/. al topos)',
      },
      fields: [
        'Por favor revise y modifique los números predeterminados en función de lo mejor de su conocimiento.',
      ],
      unit: { ha: 'S/. al ha', topos: 'S/. al topos' },
    },
    qu: {
      title: {
        ha: 'Jayk’ataq tarpuna kan (jayk’a soles juk hectarea)',
        topos: 'Jayk’ataq tarpuna kan (jayk’a soles juk hectarea)',
      },
      fields: ['TRANSLATE'],
      unit: {
        ha: 'Jayk’a soles juk hectarea',
        topos: 'Jayk’a soles juk hectarea',
      },
    },
  },
  {
    index: 7,
    en: {
      title: {
        ha: 'Typical crop yield (kg per ha)',
        topos: 'Typical crop yield (kg per topos)',
      },
      fields: [
        'Please review and modify the default numbers based on the best of your knowledge.',
      ],
      unit: { ha: 'kg per ha', topos: 'kg per topos' },
    },
    es: {
      title: {
        ha: 'Rendimiento típico del cultivo (kg por ha)',
        topos: 'Rendimiento típico de los cultivos (kg por topos)',
      },
      fields: [
        'Por favor revise y modifique los números predeterminados en función de lo mejor de su conocimiento.',
      ],
      unit: { ha: 'kg por ha', topos: 'kg por topos' },
    },
    qu: {
      title: {
        ha: 'TRANSLATE',
        topos: 'TRANSLATE',
      },
      fields: ['TRANSLATE'],
      unit: {
        ha: 'TRANSLATE',
        topos: 'TRANSLATE',
      },
    },
  },
  {
    index: 8,
    en: {
      title: 'Scenarios',
      fields: [
        'This tool will show five scenarios:',
        scenarios.en[0],
        scenarios.en[1],
        scenarios.en[2],
        scenarios.en[3],
        scenarios.en[4],
      ],
      unit: '%',
    },
    es: {
      title: 'Escenarios',
      fields: [
        'Esta herramienta mostrará cinco escenarios:',
        scenarios.es[0],
        scenarios.es[1],
        scenarios.es[2],
        scenarios.es[3],
        scenarios.es[4],
      ],
    },
    qu: {
      title: 'TRANSLATE',
      fields: [
        'TRANSLATE',
        scenarios.qu[0],
        scenarios.qu[1],
        scenarios.qu[2],
        scenarios.qu[3],
        scenarios.qu[4],
      ],
    },
  },
  {
    index: 9,
    en: {
      title: 'Custom fixed percentage planting',
      fields: [
        scenarios.en[1],
        'For Scenario 2, please input the planting percent of the selected crop(s) between 1 to 100 below adding up to 100%.',
        'Current distribution: ',
      ],
      unit: '%',
    },
    es: {
      title: 'Porcentaje fijo personalizado de plantación',
      fields: [
        scenarios.es[1],
        'Para el escenario 2, ingrese el porcentaje de siembra de los cultivos seleccionados entre 1 y 100 por debajo de sumar hasta el 100%.',
        'Distribución actual: ',
      ],
      unit: '%',
    },
    qu: {
      title: 'TRANSLATE',
      fields: [scenarios.qu[1], , 'TRANSLATE', 'TRANSLATE'],
      unit: '%',
    },
  },
  {
    index: 10,
    en: {
      title: 'Custom planting area (%)',
      fields: [
        scenarios.en[4],
        'For Scenario 5, please enter a number between 1 to 100 below to represent the maximum percentage of available land that will be designated to a crop in the optimization process.',
      ],
      unit: '%',
    },
    es: {
      title: 'Área de plantación personalizado (%)',
      fields: [
        scenarios.es[4],
        'Para el escenario 5, coloque un número entre 1 y 100 a continuación para representar el porcentaje máximo de tierra disponible que se designará para un cultivo en el proceso de optimización.',
      ],
      unit: '%',
    },
    qu: {
      title: 'TRANSLATE',
      fields: [scenarios.qu[4], 'TRANSLATE'],
      unit: '%',
    },
  },
  {
    index: 11,
    en: {
      title: 'Crop mix',
      fields: [
        'Planting area',
        'Must select at least one crop',
        'Click each scenario for more details.',
      ],
      unit: { ha: ' (ha)', topos: ' (topos)' },
    },
    es: {
      title: 'Opciones de Mezcla de cultivos',
      fields: [
        'Area de sembrar',
        'Debe seleccionar al menos un cultivo',
        'Haga clic en cada escenario para obtener más detalles.',
      ],
      unit: { ha: 'ha', topos: 'topos' },
    },
    qu: {
      title: 'Mikhuna juñuna yanapaq',
      fields: ['Chaqra sayan', 'TRANSLATE'],
      unit: { ha: 'hectarea', topos: 'topos' },
    },
  },
  {
    index: 12,
    en: {
      title: 'Profits',
      fields: [
        'Profit (S/.) in 1,000',
        'Must select at least one crop',
        'Planting multiple crops provides more security in case one crop fails.',
        'Click each scenario for more details.',
      ],
    },
    es: {
      title: 'Ganancia con cada opcion',
      fields: [
        'S/. en 1,000',
        'Debe seleccionar al menos un cultivo',
        'Plantar varios cultivos proporciona más seguridad en caso de que un cultivo falle',
        'Haga clic en cada escenario para obtener más detalles.',
      ],
    },
    qu: {
      title: 'Ganancia akllana',
      fields: ['soles en 1,000', 'Juk mikhunallatapas akllay', 'TRANSLATE'],
    },
  },
  {
    index: 13,
    en: {
      title: 'Total Crop Water Needs',
      fields: ['Liters/month/', 'Click each scenario for more details.'],
      unit: { ha: 'ha in 1,000', topos: 'topos in 1,000' },
    },
    es: {
      title: 'Necesidades totales de agua de cultivo',
      fields: [
        'Litros/mes/',
        'Haga clic en cada escenario para obtener más detalles.',
      ],
      unit: { ha: 'ha en 1,000', topos: 'topos en 1,000' },
    },
    qu: {
      title: 'TRANSLATE',
      fields: ['TRANSLATE'],
      unit: { ha: 'hectarea en 1,000', topos: 'topos en 1,000' },
    },
  },
  {
    index: 14,
    en: {
      title:
        'Total Irrigation Time Needed (Assuming 100% irrigation efficiency)',
      fields: ['hours/month', 'Click each scenario for more details.'],
    },
    es: {
      title:
        'Tiempo total de riego necesario (suponiendo una eficiencia de riego del 100%)',
      fields: [
        'horas/mes',
        'Haga clic en cada escenario para obtener más detalles.',
      ],
    },
    qu: {
      title: 'TRANSLATE',
      fields: ['TRANSLATE'],
    },
  },
  {
    index: 15,
    en: {
      title: 'About Agricultural Optimizer',
      fields: [
        'Agricultural Optimizer is a free mobile application that provides information about crop mix planting options, profits, and total crop water needs for farmers in the Colca Valley, Peru to explore mix of crop(s) considering irrigation water availability and/or profits.',
        'Funding to support the research of the Nexus Institute of Arequipa for Food, Energy, Water and the Environment was provided by the National University of San Agustín.',
      ],
    },
    es: {
      title: 'Acerca de la herramienta de Optimizador agrícola',
      fields: [
        'La herramienta de Optimizador agrícola es una aplicación móvil gratuita que proporciona información sobre las opciones de siembra de mezclas de cultivos, las ganancias, las necesidades totales de agua de cultivo y el tiempo total de riego necesario para que los agricultores en el Valle del Colca, Perú, exploren la mezcla de cultivos teniendo en cuenta la disponibilidad de agua de riego y / o las ganancias.',
        'El financiamiento para apoyar la investigación del Instituto Nexus de Arequipa para Alimentos, Energía, Agua y Medio Ambiente fue proporcionado por la Universidad Nacional de San Agustín.',
      ],
    },
    qu: {
      title: 'TRANSLATE',
      fields: ['TRANSLATE', 'TRANSLATE'],
    },
  },
];

export const PageContext = React.createContext(pages[0]);
